import {
  GET_USER_AGREEMENTS,
  GET_USER_AGREEMENTS_SUCCESS,
  USER_AGREEMENTS_API_ERROR,
} from "./actionTypes";

export const getUserAgreements = () => ({
  type: GET_USER_AGREEMENTS,
});

export const getUserAgreementsSuccess = userAgreements => ({
  type: GET_USER_AGREEMENTS_SUCCESS,
  payload: userAgreements,
});

export const userAgreementsApiError = error => ({
  type: USER_AGREEMENTS_API_ERROR,
  payload: error,
});
